<template>
  <button
    @click="triggerDelete"
    :type="type" class="delete-human-button"
    :class="{ disabled }"
  >
    <img :id="id" src="@/assets/img/delete-participant.svg" alt="">
    <b-tooltip v-if="disabled" :target="id" triggers="hover" placement="left">
      {{ disabledTitle }}
    </b-tooltip>
  </button>
</template>

<script>
export default {
  name: 'DeleteHumanButton',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      id: Math.random().toString().slice(2, 8) + Date.now().toString().slice(0, 6),
    };
  },
  methods: {
    triggerDelete() {
      if (!this.disabled) {
        this.$emit('deleteHuman');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .delete-human-button {
    background: none;
    border: none;
    outline: none;
  }
  .delete-human-button.disabled {
    cursor: default;
    opacity: .5;
  }
</style>
